export const backToHome = 'Back to home';
